import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  NoteBox,
  NoteLabel,
  NotePlaceholder,
  StyledNoteTextField
} from './EditableNoteBox.styles';
import { updateDailyTicketNotesThunk } from '../../../../redux/dailyTickets/dailyTicketsThunks';
import { selectCurrentVenue } from '../../../../redux/slices/currentUserSlice';
// import { selectSelectedDailyTicket } from '../../../../redux/dailyTickets/dailyTicketsSlice';

const EditableNoteBox = ({ label, noteType, placeholder, noteDate, initialValue }) => {
  const dispatch = useDispatch();
  const currentVenue = useSelector(selectCurrentVenue);
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState('');

  useEffect(() => {
    // Update localValue when initialValue changes
    setLocalValue(initialValue);
  }, [initialValue]);

  const handleFocus = () => setIsEditing(true);

  const handleChange = (e) => setLocalValue(e.target.value);

  const handleBlur = () => {
    setIsEditing(false);
    if (localValue !== initialValue) {
      dispatch(updateDailyTicketNotesThunk({
        vid: currentVenue.id,
        dateString: noteDate,
        noteType,
        noteText: localValue
      }));
    }
  };

  return (
    <NoteBox>
      <NoteLabel variant="h6GrayUppercase">{label}</NoteLabel>
      {(isEditing || localValue) ? (
        <StyledNoteTextField
          fullWidth
          multiline
          value={localValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          variant="standard"
          size="small"
          InputProps={{ disableUnderline: true }}
        />
      ) : (
        <NotePlaceholder variant="body2" onClick={() => setIsEditing(true)}>
          {localValue || placeholder}
        </NotePlaceholder>
      )}
    </NoteBox>
  );
};

EditableNoteBox.propTypes = {
  label: PropTypes.string.isRequired,
  noteType: PropTypes.oneOf(['employee', 'manager']).isRequired,
  placeholder: PropTypes.string.isRequired,
  noteDate: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
};

export default EditableNoteBox;